import { mapEntity, MappedEntity } from '@toggle/toggle';
import React, { FC, useEffect, useState } from 'react';

import { postEntities } from '~/api/entities/entity-service';

import { MultipleEntityMatchesReply } from '../multiple-entity-matches/MultipleEntityMatchesReply';
import { PartialMessageProps } from '../partial-message/PartialMessage';
import { WatchlistMessageTable } from '../watchlist-message-table/WatchlistMessageTable';

export interface CreateListPartialProps {
  action: string;
  items: [Record<string, string[]>];
  info: Pick<PartialMessageProps, 'data'>['data']['info'];
}

export const CreateListPartial: FC<CreateListPartialProps> = ({
  items,
  info,
  action,
}) => {
  const { name, entities } = info;
  const [matchedEntities, setMatchedEntities] = useState<MappedEntity[]>([]);

  useEffect(() => {
    if (entities) {
      fetchData(entities);
    }
  }, [entities]);

  const fetchData = async (tags: string[]) => {
    const entities = await Promise.all(
      tags.map(tag =>
        postEntities({
          args: [tag],
          filter: 2,
        })
      )
    );

    const result = entities
      .map(entity => entity.data && mapEntity(entity.data[0]))
      .filter(Boolean) as MappedEntity[];
    setMatchedEntities(result);
  };

  const onAddToWatchlist = (entity: MappedEntity) => {
    setMatchedEntities(prev => [...prev, entity]);
  };

  return (
    <>
      {!!matchedEntities.length && (
        <WatchlistMessageTable entities={matchedEntities} name={name} />
      )}
      <MultipleEntityMatchesReply
        items={items}
        info={info}
        action={action}
        onAddToWatchlist={onAddToWatchlist}
      />
    </>
  );
};
